<template>
  <div class="row">
    <div class="col col-lg-4">
      <select
        @change="handleCityChanged"
        class="form-select"
        v-model="searchModel.cityid_voter"
      >
        <option v-for="city in cities" :key="city.id_mun" :value="city.id_mun">
          {{ city.name_mun }}
        </option>
      </select>
    </div>

    <div class="col col-lg-4">
      <select
        @change="onBrgyChanged"
        class="form-select"
        v-model="searchModel.brgyid_voter"
      >
        <option v-for="brgy in brgys" :key="brgy.id_brgy" :value="brgy.id_brgy">
          {{ brgy.name_brgy }}
        </option>
      </select>
    </div>

    <div class="col col-lg-4">
      <select
        @change="onBrgyChanged"
        class="form-select"
        v-model="searchModel.type_voter"
      >
        <option v-for="vtype in voterTypes" :key="vtype.code" :value="vtype.code">
          {{ vtype.label }}
        </option>
      </select>
    </div>
  </div>

  <div class="row">
    <!-- Left Column (Drop Area) -->
    <div class="col-lg-6">
      <h3>Assigned Names</h3>
      <draggable
        v-model="assignedNames"
        group="people"
        @change="onDrop"
        class="drop-area"
        item-key="id"
      >
        <template #item="{ element }">
          <div class="assigned-item d-flex align-items-center p-2">
            <i class="bi bi-person-circle me-2 text-danger"></i>
            <div class="flex-grow-1">
              <strong>{{ element.name_voter }}</strong>
              <div class="small text-muted">
                <i class="bi bi-geo-alt-fill"></i> Precinct:
                {{ element.precinct_voter }} | <i class="bi bi-geo-alt"></i> Clustered:
                {{ element.watcher_voter }} | <i class="bi bi-person-badge"></i> Type:
                {{ element.type_voter }}
              </div>
            </div>
          </div>
        </template>
      </draggable>
    </div>

    <!-- Right Column (Available Names) -->
    <div class="col-lg-6">
      <h3>Not Yet Assigned Supporters</h3>
      <form @submit.stop.prevent="search">
        <label for="name_voter">Enter Keyword:</label>
        <input
          placeholder="Enter search keyword"
          id="name_voter"
          v-model="searchModel.name_voter"
          class="form-control"
          type="text"
        />
      </form>
      <draggable
        v-model="availableNames"
        @change="onRemove"
        group="people"
        class="name-list"
        item-key="id"
      >
        <template #item="{ element }">
          <div class="assigned-item d-flex align-items-center p-2">
            <i class="bi bi-person-circle me-2 text-secondary"></i>
            <div class="flex-grow-1">
              <strong>{{ element.name_voter }}</strong>
              <div class="small text-muted">
                <i class="bi bi-geo-alt-fill"></i> Precinct:
                {{ element.precinct_voter }} | <i class="bi bi-geo-alt"></i> Clustered:
                {{ element.watcher_voter }} | <i class="bi bi-person-badge"></i> Type:
                {{ element.type_voter }}
              </div>
            </div>
          </div>
        </template>
      </draggable>
    </div>
  </div>
</template>

<script>
import areaService from "@/services/areaService";
import customizationService from "@/services/customizationService";
import spinnerService from "@/services/spinnerService";
import voterService from "@/services/voterService";
import { onMounted, ref, watch } from "vue";
import draggable from "vuedraggable";

export default {
  components: { draggable },
  setup() {
    const availableNames = ref([]);
    const brgys = ref([]);
    const cities = ref([]);
    const assignedNames = ref([]);
    const voterTypes = ref([]);
    const searchModel = ref({
      type_voter: "",
      cityid_voter: 0,
      brgyid_voter: 0,
      currentPage: 1,
    });
    const getMunicipalities = async () => {
      cities.value = await areaService.getMunicipalities();
      if (cities.value !== null && cities.value.length == 1) {
        searchModel.value.municipality_voter = cities.value[0].name_mun;
        searchModel.value.cityid_voter = cities.value[0].id_mun;
      }
      voterTypes.value = customizationService.getRankedVoterTypesByCity(
        searchModel.value.cityid_voter
      );
      await getBrgys();
    };
    const onDrop = (event) => {
      if (event.added) {
        console.log("Dropped item:", event.added.element);
      }
    };

    const onRemove = (event) => {
      if (event.added) {
        console.log("Dropped item:", event.added.element);
      }
    };
    const handleCityChanged = async () => {
      voterTypes.value = customizationService.getRankedVoterTypesByCity(
        searchModel.value.cityid_voter
      );
      await getBrgys();
    };

    const getBrgys = async () => {
      brgys.value = await areaService.getBrgys(searchModel.value.cityid_voter);
    };

    const search = async () => {
      if (searchModel.value.cityid_voter === 0 || searchModel.value.brgyid_voter === 0)
        return;
      spinnerService.show();
      searchModel.value.currentPage = 1;
      const resp = await voterService.searchVoterForGroupings(searchModel.value);
      availableNames.value = resp.voters;
      spinnerService.hide();
    };

    onMounted(() => {
      const storedItem = localStorage.getItem("grouping-searchModel");
      if (storedItem) {
        searchModel.value = JSON.parse(storedItem);
      }
      getMunicipalities();
    });

    watch(
      searchModel,
      (newValue) => {
        localStorage.setItem("grouping-searchModel", JSON.stringify(newValue));
      },
      { deep: true }
    );

    return {
      availableNames,
      assignedNames,
      searchModel,
      brgys,
      cities,
      search,
      voterTypes,
      handleCityChanged,
      onDrop,
      onRemove,
    };
  },
};
</script>

<style scoped>
.drop-area,
.name-list {
  min-height: 200px;
  border: 2px dashed #ccc;
  padding: 10px;
  background: #f8f9fa;
}

.assigned-item,
.name-item {
  padding: 8px;
  margin: 5px 0;
  background: #c9625f;
  color: #fff;
  border-radius: 5px;
  cursor: grab;
  text-align: center;
}
</style>
